/* eslint-disable camelcase,no-undef */
import store from '../store/store'
import router from '../router'

const URI_SIGN_UP = '/auth/signup'

class Auth {
  /** Restore session after reload page */
  constructor() {
    let token = window.localStorage.getItem('access_token') ? window.localStorage.getItem('access_token') : window.sessionStorage.getItem('access_token')
    if (token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      this.getUser()
    }
  }

  async setLoginData(data) {
    let storage = true ? 'localStorage' : 'localStorage'
    window[storage].setItem('access_token', data.access_token)
    window[storage].setItem('refresh_token', data.refresh_token)
    this.setRefreshInterceptor(data.refresh_token)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
    await this.getUser();
    window.location.reload();
  }

  register(data){
   return  axios.post(URI_SIGN_UP, data);
  }

  login(data) {
    let storage = true ? 'localStorage' : 'localStorage'
    return new Promise((resolve, reject) => {
      axios.post('/auth/login', data)
        .then(({data}) => {
          window[storage].setItem('access_token', data.access_token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token;
          this.getUser().then(() => {
            resolve();
          })
        })
        .catch(err => {
          reject(err)
        })
    })
  };
  logout() {
    window.localStorage.removeItem('access_token')
    window.sessionStorage.removeItem('refresh_token')
    store.commit('auth/logout')
    router.push({name: 'Login'})
  }
  getUser() {
    return new Promise((resolve, reject) => {
      axios.get('/auth/user').then(({data}) => {
        store.commit('auth/setUser', data)
        resolve()
      }).catch(e => {
        this.logout()
      })
    })
  }

  check() {
    return store.getters['auth/loggedIn']
  }
}

export default Auth
